import { endpoints, headerConfigs } from "@/utils/config";
import { trackKlaviyoEvent } from "@/utils/klaviyo-metric";

export const fetchCart = async () => {
  const result = await fetch(endpoints.cart, {
    method: "GET",
    ...headerConfigs,
  });
  const response = await result.json();
  return response;
};

export const fetchAddItem = async payload => {
  let products = Array.isArray(payload) ? payload : [payload];

  try {
    const result = await fetch(endpoints.add, {
      method: "POST",
      body: JSON.stringify({
        items: products,
      }),
      ...headerConfigs,
    });
    const response = await result.json();
    trackAddedToCart(response.items?.[0]);
    return response;
  } catch (error) {
    console.error(error.message);
    return error.message;
  }
};

export const applyDiscountLineItem = async ({discountCode}) => {
  const url = new URL(`${location.origin}/discount/${discountCode}`);

  return await fetch(url, {
    method: "GET",
    ...headerConfigs,
  });
};

export const fetchUpdateItem = async payload => {
  const updates = {};

  const {item, type} = payload;
  const quantity = type === "increment" ? item.quantity + 1 : item.quantity - 1;

  if ((type === "decrement" && item.quantity > 0) || type === "increment") {
    updates[item.key] = quantity;

    try {
      const result = await fetch(endpoints.update, {
        method: "POST",
        body: JSON.stringify({
          updates,
        }),
        ...headerConfigs,
      });
      const response = await result.json();
      return response;
    } catch (error) {
      console.error(error.message);
      return error.message;
    }
  }
};

export const fetchRemoveItem = async payload => {
  let products = Array.isArray(payload) ? payload : [payload];

  const mappedPayload = products.reduce((acc, i) => {
    acc[i.key] = 0;
    return acc;
  }, {});

  try {
    const result = await fetch(endpoints.update, {
      method: "POST",
      body: JSON.stringify({
        updates: mappedPayload,
      }),
      ...headerConfigs,
    });

    const response = await result.json();
    return response;
  } catch (error) {
    console.error(error.message);
    return error.message;
  }
};

const trackAddedToCart = (item) => {
  const klaviyoItem = {
    Name: item.title,
    ProductID: item.product_id,
    ImageURL: item.featured_image.url,
    URL: 'https://' + location.hostname + item.url,
    Brand: "Primal Harvest",
    Price: item.final_price,
    CompareAtPrice: item.selling_plan_allocation?.compare_at_price || item.original_price,
    Subscription: item.selling_plan_allocation?.selling_plan?.name,
    Quantity: item.quantity,
  };

  trackKlaviyoEvent('Added to Cart', klaviyoItem);
}
